// routes/AppRoutes.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Pages
import HomePage from "../pages/HomePage";
import ProductDetails from "../pages/ProductDetails";
import CheckoutPage from "../pages/CheckoutPage";
import Contact from "../pages/Contact";
import AboutPage from "../pages/AboutPage";
import DevisPage from "../pages/DevisPage";
import ProductsPage from "../pages/ProductsPage";
import PrivacyPolicy from "../pages/PrivacyPolicy";

// Auth Components
import LoginForm from "../Auth/components/LoginForm";
import RegisterForm from "../Auth/components/RegisterForm";

// Admin Components
import AdminDashboard from "../Admin/AdminDashboard";
import PrivateRoute from "./PrivateRoute";

// Client Components
// import ClientLogin from "../Admin/ClientCheckout/Login/ClientLogin";
import ClientCheckout from "../Admin/ClientCheckout/Login/ClientCheckout";
import CheckoutFormContainer from "../Admin/ClientCheckout/Login/CheckoutForm";
import ClientDashboard from "../Admin/ClientCheckout/ClientPage/ClientDashboard";

// Other Components
// import EcoBagCustomizer from "../pages/EcoBagCustomizer/EcoBagCustomizer";
import TestPayment from "../Admin/Payment/TestPayment";
import PaymentSuccess from "../Admin/Payment/PaymentSuccess";
import UnauthorizedPage from "../components/UnauthorizedPage";
// import OrderTest from "../pages/OrderTest";

const AppRoutes = () => {
    return (
        <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/details/:id" element={<ProductDetails />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/devis" element={<DevisPage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />

            {/* Auth Routes */}
            <Route path="/login" element={<LoginForm />} />
            <Route path="/register" element={<RegisterForm />} />

            {/* Client Routes */}
            <Route path="/Client/Checkout/:token" element={<ClientCheckout />} />
            <Route path="Client/Payement/:token" element={<CheckoutFormContainer />} />
            <Route path="/client/dashboard/:id" element={<ClientDashboard />} />
            <Route path="/client/dashboard/:quoteId/payment-success" element={<PaymentSuccess />} />

            {/* Test/Demo Routes */}
            {/* <Route path="Test/Product" element={<EcoBagCustomizer />} /> */}
            <Route path="/payment-test" element={<TestPayment />} />

            {/* Error Routes */}
            <Route path="/unauthorized" element={<UnauthorizedPage />} />
            {/* <Route path="/Order-Test" element={<OrderTest />} /> */}

            {/* Admin Routes - Protected */}
            <Route
                path="/dashboard-ecobag-secure/*"
                element={
                    <PrivateRoute>
                        <AdminDashboard />
                    </PrivateRoute>
                }
            />

            {/* Fallback Route */}
            <Route path="*" element={<Navigate to="/" />} />

            
        </Routes>
    );
};

export default AppRoutes;